export default {
  dark: {},
  light: {},
};
